<template>
  <div>
    <div class="btn-wrapper mb-10 move-right grid-full">
      <router-link to="/admin/hrm/leave/settings" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <div class="relative adjust-height">
      <div class="inner-table relative">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="flex blue">Leave Approver Setting</div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <div class="media-group flex"></div>
          <div class="relative leave-search">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div
            class="btn-wrapper mb-10 move-right"
            v-if="leaveApprovalSettingsData.length"
          >
            <router-link
              to="/admin/hrm/leave/settings/leave-approval/create"
              class="btn btn-blue btn-full-radius inline-flex flex-v-end"
            >
              <span> + New Approver</span>
            </router-link>
          </div>
        </div>
        <LeaveApprovalSettingsTable
          @toggleView="toggleView"
          @handleSelectionChange="handleSelectionChange"
          :overlayLoading="overlayLoading || loader"
          @resetTable="resetTable"
          :searchQuery="searchQuery"
        />
        <LeaveApprovalDetails
          :show="show"
          @toggleView="toggleView"
          :leaveApprover="leaveApprover"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import LeaveApprovalSettingsTable from "../components/LeaveApprovalSettingsTable";
import LeaveApprovalDetails from "../components/LeaveApprovalDetails.vue";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  components: {
    LeaveApprovalSettingsTable,
    LeaveApprovalDetails,
  },
  data() {
    return {
      show: false,
      loading: false,
      multipleSelection: [],
      overlayLoading: false,
    };
  },
  mounted() {
    this.searchLeaveApprovers();
  },
  computed: {
    ...mapState({
      view: "showViewContainer",
      leaveApprover: "currentLeaveApprover",
      employees: "Employees",
      leaveApprovalSettingsData: "leaveApprovers",
      loader: "viewContainerLoading",
    }),
    showDeleteButton() {
      return this.multipleSelection.length;
    },
    searchQuery: {
      get() {
        return this.$store.state.admin.hrm.leave.searchQuery;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/searchQuery", value);
      },
    },
  },
  methods: {
    ...mapActions(["searchLeaveApprovers", "getLeaveApproverById"]),
    search: debounce(function() {
      this.searchLeaveApprovers();
    }, 500),
    resetTable() {
      this.searchQuery = "";
      this.searchLeaveApprovers();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleView(row) {
      if (!row) {
        this.show = false;
        return;
      }
      this.overlayLoading = true;
      this.getLeaveApproverById(row.id)
        .then(response => {
          this.currentLeaveApprover = response;
          this.show = !this.show;
          this.overlayLoading = false;
        })
        .catch(() => {
          this.show = false;
          this.overlayLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.leave-search {
  margin-left: auto;
}
</style>
